import { connect } from 'react-redux';
import { Actions } from '../actions';
import Communications from '../components/Communications';

const mapStateToProps = state => {
    return state;
};

export default connect(mapStateToProps, Actions)(Communications);
